import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { UnitService } from '@application/unit.service';
import { UniversalConfig } from '@application/universal_config.service';
import { IllustrativeView } from '@component/illustrative_view.component';
import { TopBar } from '@component/top_bar.component';
import { RuleSetType } from '@visiba/api-vcs-client-v2';
import { useResolve } from '@visiba/instantiation';
import { useEffect } from 'react';
import { useCreateNewMessage } from '../../hooks/use-create-new-message';
import { OpeningHours } from './use-opening-hours';

export function ScreenClosed() {
	const { flowData, goToReceptionHome } = useCreateNewMessage();
	const universalConfig = useResolve(UniversalConfig);
	const unitService = useResolve(UnitService);
	const unit = unitService.getUnitNodeInTree(universalConfig.selectedUnitId);
	const receptionId = unit.receptionId;
	const openingHours = OpeningHours({ type: RuleSetType.Messaging, receptionId });
	const analytics = useAnalyticContext();

	const closedReason = flowData.flowState === 'accessible' ? (flowData.value.closedReason ?? 'Other') : 'Other';

	function handleGoToHome() {
		analytics.trackEvent('Clicked', 'Go to home button');
		goToReceptionHome();
	}

	function numbers() {
		const country = universalConfig.selectedCountryCode.peek();

		switch (country) {
			case 'SE':
				return {
					emergency: '112',
					nonEmergency: '1177',
				};
			case 'NO':
				return {
					emergency: '113',
					nonEmergency: '116 117',
				};
			case 'FI':
				return {
					emergency: '112',
					nonEmergency: '116 117',
				};
			case 'GB':
				return {
					emergency: '999',
					nonEmergency: 'NHS 111',
				};
			default:
				return {
					emergency: '-',
					nonEmergency: '-',
				};
		}
	}

	useEffect(() => {
		analytics.service.trackPageView({ customTitle: 'Create new message: Closed' });
	}, [analytics]);

	return (
		<>
			<TopBar.Content onAbort={null} />
			<IllustrativeView
				title={withTranslation(`View.CreateNewMessage.Closed.${closedReason}Title`)}
				description={withTranslation(`View.CreateNewMessage.Closed.${closedReason}Body`, {
					emergencyNumber: numbers().emergency,
					nonEmergencyNumber: numbers().nonEmergency,
				})}
				illustration='closed'
				callToAction={withTranslation('View.CreateNewMessage.Closed.Button')}
				callToActionCallback={handleGoToHome}
				content={openingHours}
			/>
		</>
	);
}
